import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-group-inputs',
  templateUrl: './form-group-inputs.component.html',
  styleUrls: ['./form-group-inputs.component.scss']
})
export class FormGroupInputsComponent {


  @Input() state : Record<string , string | Date | number | null> = {}




}
